<template>
  <vue-final-modal
    :model-value="showModal"
    :click-to-close="false"
    class="modal-confirm-bonus"
    :overlay-transition="{ mode: 'in-out', duration: 200 }"
    :content-transition="{ mode: 'in-out', duration: 200 }"
  >
    <div class="modal-confirm-bonus__scroll">
      <div class="modal-confirm-bonus__header">
        <button-modal-close
          class="modal-confirm-bonus__close"
          @close="emit('closeModal')"
        />
        <div class="modal-confirm-bonus__title">
          {{ title }}
        </div>
      </div>

      <div class="modal-confirm-bonus__text">
        {{ interpolatedDescription }}
      </div>

      <div class="modal-confirm-bonus__actions">
        <button-base
          type="primary"
          size="md"
          :is-disabled="bonusesUpdating"
          :is-processing="bonusesUpdating"
          @click="emit('confirm')"
        >
          {{ confirmButton }}
        </button-base>
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal';

defineProps<{
  showModal: boolean;
  title?: string;
  interpolatedDescription?: string;
  confirmButton?: string;
  cancelButton?: string;
  bonusesUpdating?: boolean;
}>();

const emit = defineEmits(['closeModal', 'confirm']);
</script>

<style src="~/assets/styles/components/modal/confirm-bonus.scss" lang="scss" />
